export const CHAR_SIZE = 9.6;
export const PADDING = 12;
